//import Modal from "./modules/Modal"

//const modal = new Modal();

// function openModal(el) {
//   const modal = document.getElementById(el);
//   if (modal) {
//     modal.style.display = "flex"; 
//     modal.outerHTML.classList.add= "show"; // Use 'flex' to center the modal
//   } else {
//     console.error("Modal element not found");
//   }
// }

// function closeModal(el) {
//   const modal = document.getElementById(el);
//   if (modal) {
//     modal.style.display = "none";
//   } else {
//     console.error("Modal element not found");
//   }
// }


// function saveChanges() {
//   closeModal();
// }

// window.onclick = function (event) {
//   const modal = document.getElementById("modalSopExitIntent");
//   if (modal ) {
//     modal.style.display = "none";
//   }
// };

// document.addEventListener("keydown", function (event) {
//   const modal = document.getElementById("modalSopExitIntent");
//   if (modal && event.key === "Escape") {
//     modal.style.display = "none";
//   }
// });


  document.addEventListener("DOMContentLoaded", function () {
    // Tab Navigation Logic
    const navLinks = document.querySelectorAll(".nav-tabs .nav-link");
    const tabPanes = document.querySelectorAll(".tab-pane");
  
    navLinks.forEach((link) => {
      link.addEventListener("click", function (event) {
        event.preventDefault();
  
        // Remove active class from all nav links and panes
        navLinks.forEach((nav) => nav.classList.remove("active"));
        tabPanes.forEach((pane) => pane.classList.remove("active", "show"));
  
        // Add active class to the clicked link and corresponding pane
        link.classList.add("active");
        const targetId = link.getAttribute("href").substring(1);
        const targetPane = document.getElementById(targetId);
        if (targetPane) {
          targetPane.classList.add("active", "show");
        }
      });
    });
  
    // Currency Toggle Button Logic
    const toggleButtons = document.querySelectorAll(".tri-state-toggle-button");
  
    toggleButtons.forEach((button) => {
      button.addEventListener("click", function () {
        // Remove active class from all toggle buttons
        toggleButtons.forEach((btn) => btn.classList.remove("active"));
  
        // Add active class to the clicked button
        button.classList.add("active");
      });
    });

    window.successStoriesSwiper = null;
    window.successHeroStoriesSwiper = null;
    window.initSuccessStoriesSlider = function () {
      if (window.successStoriesSwiper) {
          window.successStoriesSwiper.destroy(true, true);
      }
       
    }
    window.initSuccessHeroStoriesSlider = function () {
      if (window.successHeroStoriesSwiper) {
          window.successHeroStoriesSwiper.destroy(true, true);
      }
       
    }
  });
  
